<template>
  <div>
    {{ sampleStats }}
  </div>
</template>

<script>
export default {
  name: 'ReceivedSampleRenderer',
  data() {
    return {
      receivedSampleCount: null,
      totalSampleCount: null,
      sampleRate: null
    }
  },
  computed : {
    sampleStats() {
      if (this.totalSampleCount === 0) {
        return "N/A"
      }
     
      return this.$options.filters.toPercentage(this.sampleRate) + " (" + this.receivedSampleCount  + "/" + this.totalSampleCount  + ")";
    }
  },
  created() {
    this.totalSampleCount = this.params.value.totalSampleCount;
    this.receivedSampleCount = this.params.value.receivedSampleCount;
    this.sampleRate = this.params.value.sampleRate;
  }
}
</script>
